/* eslint-disable react/prop-types */
/* eslint-disable no-unsafe-optional-chaining */
import React from 'react';

import { getColorComboByCharacter, getNextComboByCharacter } from '../../../../../helpers/utils';

import styles from './ChatListItem.less';

const PersonAvatar = ({ data, parentData }) => {
  if (data?.avatarUrl) {
    return (
      <img
        src={data?.avatarUrl || require('Assets/images/pages/web-chat/avatar-default.png')}
        alt="news"
        className={parentData ? 'item-for' : 'image-avatar'}
      />
    );
  }
  const convertedData = data?.fullName
    ? { ...data, firstName: data.fullName.split(' ')[0], lastName: data.fullName.split(' ')[1] }
    : data;
  let colorGroup = getColorComboByCharacter(
    (
      (convertedData?.firstName || 'No')?.charAt(0) + (convertedData?.lastName || 'Name')?.charAt(0)
    )?.charAt(0),
  );
  if (parentData) {
    const parentName =
      parentData?.firstName || parentData?.lastName
        ? parentData?.firstName?.charAt(0) + parentData?.lastName?.charAt(0)
        : 'N/A';
    colorGroup = getNextComboByCharacter(parentName?.charAt(0));
  }
  const name =
    convertedData?.firstName || convertedData?.lastName
      ? convertedData?.firstName?.charAt(0) + (convertedData?.lastName?.charAt(0) || '')
      : 'N/A';
  return (
    <div
      className={
        parentData
          ? `${styles.letterAvatarPatientFor} letter-ava`
          : `${styles.letterAvatar} letter-ava`
      }
      style={{ backgroundColor: colorGroup.background, color: colorGroup.text }}>
      {name}
    </div>
  );
};
export default PersonAvatar;
